import React from 'react';
import classnames from 'classnames';

const styles = require('./card-background-component.styles.scss');


export class CardBackgroundComponent extends React.Component {
  render() {
    const className = classnames(styles.CardBackground, this.props.className);

    return (
      <div className={className}>
        { this.props.children }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/cards/background/card-background.component.jsx